import clsx from 'clsx'

type QuoteProps = {
  children: string
  cite?: string
  /**
   * default 'small'
   */
  size?: 'small' | 'medium' | 'large'
}
export const Quote = ({ children, cite, size }: QuoteProps) => {
  const autoSize =
    size !== undefined ? size : children.length < 240 ? 'medium' : 'small'

  return (
    <blockquote className={clsx('pull', autoSize)}>
      {children}
      {cite && <cite>{cite}</cite>}
    </blockquote>
  )
}
